import { DisplayStatus } from '../models/displaystatus.enum';
import { ITrackAuthority, TrackAuthority } from '../models/trackauthority';
import { SANotificatonsStatus } from './sa-notifications.enum';
import { AppConstant } from '../common/app.constant';

export class UserNotification {
  id: number;
  authorityId: number;
  read: boolean;
  message: string;
  timestamp: Date;
  authorityMessage: string | null;
  messageHeading: string;
  messageBody: string;
  headerColor?: string | null;
  authorityChangeRequestId?: number;

  constructor(userNotification: IUserNotification, trackAuthority: TrackAuthority | ITrackAuthority) {
    this.authorityChangeRequestId = userNotification.authorityChangeRequestId;
    this.id = userNotification.id;
    this.authorityId = userNotification.authorityId;
    this.read = userNotification.read;
    this.message = userNotification.message;
    this.timestamp = new Date(userNotification.timestamp);
    this.authorityMessage = this.parseAuthorityMessage(trackAuthority);
    const notificationObj = this.breakNotificationMessage(this.message);
    this.messageHeading = notificationObj.header.trim();
    this.messageBody = notificationObj.body;
    this.headerColor = this.addHeaderColor(this.messageHeading);
  }

  private breakNotificationMessage(message) {
    let indexValue = message.indexOf('-');
    let obj = { header: '', body: message };
    if (indexValue > 0) {
      obj.header = message.substring(0, indexValue);
      obj.body = message.substring(indexValue, message.length);
    }
    return obj;
  }

  private addHeaderColor(messageHeading) {
    let color = null;
    switch (messageHeading.trim()) {
      case SANotificatonsStatus.AS:
      case SANotificatonsStatus.RA:
      case SANotificatonsStatus.SR:
      case SANotificatonsStatus.ACC_MOD:
      case SANotificatonsStatus.APP_MOD:
      case SANotificatonsStatus.PROC_MOD:
      case SANotificatonsStatus.ACC:
      case SANotificatonsStatus.UNS:
        color = AppConstant.COLOR_GREEN;
        break;
      case SANotificatonsStatus.AUTH_MOD:
      case SANotificatonsStatus.TTP:
        color = AppConstant.COLOR_BLUE;
        break;
      case SANotificatonsStatus.REJ:
      case SANotificatonsStatus.REJ_MOD:
      case SANotificatonsStatus.AUTH_DEC:
        color = AppConstant.COLOR_RED;
        break;
      case SANotificatonsStatus.TIME_OUT:
      case SANotificatonsStatus.AUTR_LATER:
        color = AppConstant.COLOR_ORANGE;
        break;
    }
    return color;
  }

  private parseAuthorityMessage(trackAuthority: TrackAuthority | ITrackAuthority): string {
    let authorityMessage: string;
    authorityMessage = '';
    if (trackAuthority === null || trackAuthority === undefined) {
      return authorityMessage;
    }
    if (
      trackAuthority.ec1Number !== undefined &&
      trackAuthority.ec1Number !== null &&
      (trackAuthority.displayStatus === DisplayStatus.ACTIVE || trackAuthority.displayStatus === DisplayStatus.RELEASED)
    ) {
      authorityMessage = 'Track Authority #' + trackAuthority.ec1Number + ':';
    }
    return authorityMessage;
  }
}

export interface IUserNotification {
  id: number;
  authorityId: number;
  read: boolean;
  message: string;
  timestamp: number;
  authorityChangeRequestId: number;
}
